import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { AuthorizationObjectPermissions, AuthorizationObjectType, Business_Profile_Enum } from '@kheops/graphql';
import { globalAuthorizationAtom, currentContextAtom } from '../state';
import { WISHLIST_PAGE_DISPLAY_MODE } from '../common/state/local-storage-keys';
import { DisplayMode } from '../search/state/state';


export interface WishlistProductItem {
  id: string;
  supplier_id: string;
  sku: number;
  created_at: string;
}

export interface WishlistSupplierItem {
  id: string;
  supplier_id: string;
  created_at: string;
}

export const wishlistItemsAtom = atom<WishlistProductItem[]>([]);

export const wishlistSupplierAtom = atom<WishlistSupplierItem[]>([]);

export const wishlistLoadingAtom = atom<boolean>(true);

export const canAccessWishlistAtom = atom(
  (get) => get(currentContextAtom).realm === Business_Profile_Enum.Buyer && get(globalAuthorizationAtom).some(
    (authorization) => authorization.permission === AuthorizationObjectPermissions.CanAccessWishlist
      && authorization.object === AuthorizationObjectType.Company,
  ),
);

export const wishlistDisplayModeAtom = atomWithStorage<DisplayMode>(WISHLIST_PAGE_DISPLAY_MODE, DisplayMode.GRID);

export type WishlistTab = 'product' | 'supplier';

export const wishlistActiveTabAtom = atom<WishlistTab>('product');
